import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DashboardDto } from '../dtos/dashboard/dashboard-dto';
import { IndicadorDto } from '../dtos/dashboard/indicador-dto';
import { UrlService } from './url.service';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  assuntoDash: Subject<boolean> = new Subject<boolean>();

  constructor(private http: HttpClient, private url: UrlService) { }

  gerarDashboard(): Observable<DashboardDto> {
    return this.http.get<DashboardDto>(this.url.url('dashboard'));
  }  

  contarAgendamentosHoje(): Observable<IndicadorDto> {
    return this.http.get<IndicadorDto>(this.url.url('dashboard/agendamentos-hoje'));
  }  

  contarAcompanhamentosAtivos(): Observable<IndicadorDto> {
    return this.http.get<IndicadorDto>(this.url.url('dashboard/acompanhamentos-ativos'));
  }  

  atualizarDash() {
    this.assuntoDash.next(true);
  }

  

  

}
